// api.js
import axios from "axios";
import { toast } from "react-toastify";

const api = axios.create({
  // baseURL: "http://13.213.208.92:7080/ecssms/api/",
  baseURL: "https://hrisasia.com/ecssms/api/",
  // baseURL: "https://artylearning.com/artyprod/api/",
});

// Add a request interceptor
api.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const backendMessage = error?.response?.data?.message;
    const config = error?.config;

    // ✅ SAFE optional chaining
    if (config?.skipErrorToast) {
      return Promise.reject(error);
    }

    // 🔴 Handle 401 Unauthorized
    if (status === 401 && !config?.skipAuth) {
      localStorage.removeItem("token");

      toast.error("Session expired. Please login again.");

      setTimeout(() => {
        window.location.href = "/sms/login";
      }, 1000);
    }
    // 🔴 Global error toast (exclude 409)
    else if (backendMessage && status !== 409) {
      toast.error(backendMessage);
    }

    return Promise.reject(error);
  }
);


export default api;
